var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-cloud",
    clipPath: "url(#clip0_5633_14100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66502 14.1667L9.99836 17.5M9.99836 17.5L13.3317 14.1667M9.99836 17.5V10M17.3984 15.075C18.1229 14.5655 18.6662 13.8385 18.9494 12.9993C19.2327 12.1601 19.2412 11.2525 18.9737 10.4082C18.7062 9.56387 18.1766 8.82675 17.4617 8.30381C16.7469 7.78087 15.884 7.49931 14.9984 7.50001H13.9484C13.6977 6.52323 13.2288 5.61605 12.5768 4.84674C11.9248 4.07743 11.1068 3.46606 10.1844 3.05863C9.26192 2.65121 8.25906 2.45836 7.2513 2.4946C6.24353 2.53084 5.25712 2.79523 4.36632 3.26786C3.47552 3.74049 2.70354 4.40905 2.10851 5.2232C1.51348 6.03735 1.1109 6.97588 0.931075 7.96813C0.751249 8.96038 0.798866 9.9805 1.07034 10.9517C1.34182 11.9229 1.83007 12.8198 2.49836 13.575",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5633_14100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.06c7fd243d7ffd34b4258dbe464e4a00.svg";
export { ForwardRef as ReactComponent };